import { gql } from "@apollo/client";

export const CREATE_EQUIPMENT_PURCHASE_ORDER = gql`
    mutation createPurchaseOrder($number: String!, $vendorName: String!, $orderDate: Date!, $totalCents: Int!, $items: [EquipmentPurchaseOrderItemInputType], $job: ID) {
        createEquipmentPurchaseOrder(number: $number, vendorName: $vendorName, orderDate: $orderDate, totalCents: $totalCents, items: $items, job: $job) {
            equipmentPurchaseOrder {
                id
            }
        }
    }
`

export const EDIT_EQUIPMENT_PURCHASE_ORDER = gql`
    mutation editPurchaseOrder($id: Int!, $number: String!, $vendorName: String!, $orderDate: Date!, $totalCents: Int!, $itemsToUpdate: [EditEquipmentPurchaseOrderItemInputType], $itemsToAdd: [EquipmentPurchaseOrderItemInputType], $itemsToDelete: [Int], $job: ID) {
        editEquipmentPurchaseOrder(id: $id, number: $number, vendorName: $vendorName, orderDate: $orderDate, totalCents: $totalCents, itemsToUpdate: $itemsToUpdate, itemsToAdd: $itemsToAdd, itemsToDelete: $itemsToDelete, job: $job) {
            equipmentPurchaseOrder {
                id
            }
        }
    }
`
export const DELETE_EQUIPMENT_PURCHASE_ORDER = gql`
    mutation deleteEquipmentPurchaseOrder($id: Int!) {
        deleteEquipmentPurchaseOrder(id: $id) {
            didDelete
        }
    }
`
